import action from 'app/lib/action';
import {STORE_DOC} from '../constants/actionTypes';

export default {
    request : (utrac, formData) => action(STORE_DOC.REQUEST)({utrac, formData}),
    success : (doc) => action(STORE_DOC.SUCCESS)({doc}),
    error   : (error) => action(STORE_DOC.ERROR)({error})
};